import React from 'react';
import SEO from '../components/SEO';

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '40px 40px',
    fontFamily: '"Times New Roman", Times, serif',
    lineHeight: '1.6',
    color: '#333',
    backgroundColor: '#fff',
    paddingTop: '40px',
  },
  heading: {
    fontSize: '28px',
    fontWeight: '400',
    margin: '0 0 20px 0',
    letterSpacing: '1px',
    color: '#333',
    fontFamily: '"Times New Roman", Times, serif',
    textAlign: 'left',
  },
  subHeading: {
    fontSize: '18px',
    fontWeight: '400',
    margin: '40px 0 15px 0',
    color: '#333',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontFamily: '"Times New Roman", Times, serif',
  },
  text: {
    fontSize: '16px',
    color: '#333',
    lineHeight: '1.6',
    marginBottom: '20px',
    fontFamily: '"Times New Roman", Times, serif',
  },
  list: {
    listStyle: 'disc',
    paddingLeft: '20px',
    marginBottom: '20px',
  },
  listItem: {
    fontSize: '16px',
    color: '#333',
    lineHeight: '1.6',
    marginBottom: '10px',
    fontFamily: '"Times New Roman", Times, serif',
  },
  criteria: {
    border: '1px solid #ccc',
    padding: '20px',
    marginBottom: '30px',
    backgroundColor: '#fff',
  },
  criteriaTitle: {
    fontSize: '16px',
    fontWeight: '400',
    color: '#333',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '10px',
    fontFamily: '"Times New Roman", Times, serif',
  }
};

function InvestmentCriteria() {
  return (
    <div style={styles.container}>
      <SEO
        title="Investment Criteria and Insights - Sapienta VC"
        description="Learn about Sapienta VC's investment criteria, focus areas, and insights for startups seeking venture capital funding."
        keywords="investment criteria, venture capital, startup funding, AI investments, fintech funding, payment technology"
        url="https://sapienta.vc/investment-criteria"
      />


      <p style={styles.text}>
        Sapienta VC focuses on ambitious projects that leverage cutting-edge technology to transform industries.
        Our investment thesis centers on three core areas: Payment Innovation, Technology Excellence, and AI-Driven Solutions.
      </p>

      <h2 style={styles.subHeading}>Investment Focus Areas</h2>

      <div style={styles.criteria}>
        <h3 style={styles.criteriaTitle}>Payment Innovation</h3>
        <p style={styles.text}>
          We invest in companies revolutionizing financial transactions and payment systems. This includes:
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Digital payment platforms and fintech infrastructure</li>
          <li style={styles.listItem}>Cryptocurrency and blockchain-based financial services</li>
          <li style={styles.listItem}>Cross-border payment solutions</li>
          <li style={styles.listItem}>Embedded finance and banking-as-a-service</li>
        </ul>
      </div>

      <div style={styles.criteria}>
        <h3 style={styles.criteriaTitle}>Artificial Intelligence & Machine Learning</h3>
        <p style={styles.text}>
          We back companies building intelligent solutions that transform industries:
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>AI-powered automation and workflow optimization</li>
          <li style={styles.listItem}>Machine learning platforms and infrastructure</li>
          <li style={styles.listItem}>Computer vision and natural language processing applications</li>
          <li style={styles.listItem}>AI-driven analytics and decision-making tools</li>
        </ul>
      </div>

      <div style={styles.criteria}>
        <h3 style={styles.criteriaTitle}>Technology Excellence</h3>
        <p style={styles.text}>
          We support cutting-edge technology companies building the infrastructure for the future:
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Developer tools and software infrastructure</li>
          <li style={styles.listItem}>Cloud computing and data management solutions</li>
          <li style={styles.listItem}>Cybersecurity and privacy technologies</li>
          <li style={styles.listItem}>Enterprise software and productivity tools</li>
        </ul>
      </div>

      <h2 style={styles.subHeading}>Investment Criteria</h2>

      <h3 style={styles.criteriaTitle}>Stage</h3>
      <p style={styles.text}>
        We primarily invest in Seed and Series A rounds, with occasional pre-seed and Series B investments
        for exceptional opportunities.
      </p>

      <h3 style={styles.criteriaTitle}>Check Size</h3>
      <p style={styles.text}>
        Our typical investment range is $250K to $2M, with the ability to lead or co-invest in larger rounds
        for portfolio companies.
      </p>

      <h3 style={styles.criteriaTitle}>Geography</h3>
      <p style={styles.text}>
        While we have a global perspective, we focus primarily on companies based in North America and Europe,
        with selective investments in other regions.
      </p>

      <h2 style={styles.subHeading}>What We Look For</h2>

      <ul style={styles.list}>
        <li style={styles.listItem}>
          <strong>Exceptional founders</strong> with deep domain expertise and proven execution ability
        </li>
        <li style={styles.listItem}>
          <strong>Large addressable markets</strong> with clear paths to significant scale
        </li>
        <li style={styles.listItem}>
          <strong>Defensible technology</strong> or business models with sustainable competitive advantages
        </li>
        <li style={styles.listItem}>
          <strong>Evidence of product-market fit</strong> or clear progression toward achieving it
        </li>
        <li style={styles.listItem}>
          <strong>Strong unit economics</strong> and viable paths to profitability
        </li>
      </ul>

      <h2 style={styles.subHeading}>Application Process</h2>

      <p style={styles.text}>
        We welcome applications from ambitious founders building transformative companies.
        Please include a brief executive summary, pitch deck, and financial projections when reaching out.
      </p>

      <p style={styles.text}>
        For investment inquiries, contact us at <a href="mailto:contact@sapienta.vc" style={{color: '#666', textDecoration: 'underline'}}>contact@sapienta.vc</a>
      </p>
    </div>
  );
}

export default InvestmentCriteria;